import { render, staticRenderFns } from "./DiaForm.vue?vue&type=template&id=401574bf&scoped=true&"
import script from "./DiaForm.vue?vue&type=script&lang=js&"
export * from "./DiaForm.vue?vue&type=script&lang=js&"
import style0 from "./DiaForm.vue?vue&type=style&index=0&id=401574bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401574bf",
  null
  
)

export default component.exports